import { apiService, validateAndAssert } from '@app/services/api-service';
import { TeamMemberInDto, TeamOutDto, UserOutDto } from '@app/swagger-types';
import { TeamMemberOutDtoSchema, TeamOutDtoSchema } from './team.schema';

// TODO: Add validateAndAssert's validation
export abstract class TeamApi {
  static async getTeamById(id: TeamOutDto['id']) {
    return validateAndAssert(apiService.get(`/private/teams/${id}`), TeamOutDtoSchema);
  }
  static async getTeamMembers(
    teamId: TeamOutDto['id'],
    params?: {
      statuses?: string[];
      roles?: string[];
      term?: string;
      fields?: string;
      page?: number;
      size?: number;
      sort?: string;
    }
  ) {
    // TODO: Add validateAndAssert's validation
    // return await validateAndAssert(
    //   (
    //     await apiService.get(`/private/teams/${teamId}/members`, { params })
    //   ).data,
    //   pageableData(TeamMemberOutDtoSchema)
    // );

    return (await apiService.get(`/private/teams/${teamId}/members`, { params })).data;
  }
  static async inviteTeamMembers(body: TeamMemberInDto) {
    await validateAndAssert(apiService.post('/private/teams/members', body), TeamMemberOutDtoSchema);
  }
  static async deleteTeamMember(
    teamId: NonNullable<UserOutDto['teamId']>,
    teamMemberId: NonNullable<TeamOutDto['id']>
  ) {
    await apiService.delete(`/private/teams/${teamId}/members/${teamMemberId}`);
  }
}
